import React from "react";
import {
  ManageCensusHistoryContainer,
  ManageCensusTransactionsContainer,
} from "../../../containers";

const ManageCensusTransactions = (props) => {
  return <ManageCensusTransactionsContainer {...props} />;
};

export default ManageCensusTransactions;
